import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import {
  clearMlistApiTokens,
  hasMlistApiAuth,
} from "../../api/mlistAuth";
import { getMlistApiConfig, isMlistApiConfigured } from "../../api/mlistClient";

const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  padding: 10px 12px;
  margin-top: 12px;
  font-size: 13px;
  border: 1px solid ${(p) => (p.$ok ? "#cfe6cf" : "#f0e0a8")};
  background: ${(p) => (p.$ok ? "#f4fff4" : "#fffbeb")};
  color: ${(p) => (p.$ok ? "#1f5f1f" : "#6b5700")};
`;

const Button = styled.button`
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #d0d0d0;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
`;

/**
 * Shows mlist-api JWT status for admin-tools bridge panels.
 * Independent of legacy Django hoodie session login.
 */
export default function AdminToolsMlistAuthStatus() {
  const location = useLocation();
  const [authenticated, setAuthenticated] = useState(hasMlistApiAuth());

  const refresh = useCallback(() => {
    setAuthenticated(hasMlistApiAuth());
  }, []);

  useEffect(() => {
    refresh();
    const onStorage = (e) => {
      if (
        e.key === "accessToken" ||
        e.key === "refreshToken" ||
        e.key === null
      ) {
        refresh();
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [refresh]);

  function handleLogout() {
    clearMlistApiTokens();
    refresh();
  }

  const apiConfig = getMlistApiConfig();

  if (!isMlistApiConfigured()) {
    return (
      <Bar $ok={false}>
        <span>
          <strong>MList API auth:</strong> not configured — set{" "}
          <code>REACT_APP_MLIST_API_BASE_URL</code>
        </span>
      </Bar>
    );
  }

  if (!apiConfig.valid) {
    return (
      <Bar $ok={false}>
        <span>
          <strong>MList API auth:</strong> invalid base URL —{" "}
          {apiConfig.errorMessage}
        </span>
        <Link to="/admin-tools/login" style={{ fontSize: 12 }}>
          Fix URL
        </Link>
      </Bar>
    );
  }

  const returnTo =
    location.pathname.startsWith("/admin-tools/login")
      ? "/admin-tools"
      : location.pathname + location.search;

  return (
    <Bar $ok={authenticated}>
      <span>
        <strong>
          {authenticated
            ? "MList API authenticated"
            : "MList API auth missing"}
        </strong>
        <span style={{ opacity: 0.85 }}>
          {" "}
          — for relationship bridge panels only (not legacy hoodie session).
        </span>
      </span>
      <span style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {!authenticated ? (
          <Link
            to="/admin-tools/login"
            state={{ from: returnTo }}
            style={{ fontSize: 12 }}
          >
            MList API login
          </Link>
        ) : null}
        {authenticated ? (
          <Button type="button" onClick={handleLogout}>
            Log out MList API
          </Button>
        ) : null}
      </span>
    </Bar>
  );
}
